export interface ReturnBorrowLendCollectionRequest {
  collections: {
    id: number // 資料ID
    collectionNo: string
  }[]
}

export function ReturnBorrowLendCollectionRequestToJSON(
  value: ReturnBorrowLendCollectionRequest
): any {
  return {
    collections:
      value.collections.length !== 0
        ? value.collections.map(collection => {
            return {
              id: collection.id !== 0 ? collection.id : undefined,
              collection_no:
                collection.collectionNo !== ''
                  ? collection.collectionNo
                  : undefined
            }
          })
        : undefined
  }
}
